export enum PhoneDeviceType {
  IOS = 'IOS',
  Android = 'ANDROID',
}
